import { getIn, useFormikContext } from 'formik'

import { CONTACT_GROUP_ERROR_KEY, NAME_GROUP_ERROR_KEY } from '../../typings'
import type {
  UpdateRequiredFieldsErrors,
  UpdateRequiredFieldsFormModel,
} from '../../typings'

type GroupKey = typeof NAME_GROUP_ERROR_KEY | typeof CONTACT_GROUP_ERROR_KEY

/**
 * Group-level (OR-group) error for the name or contact inputs. The message is only reported once
 * the user has interacted with a member input or tried to submit, so the group is not red on open.
 */
export function useGroupError(groupKey: GroupKey, members: readonly string[]) {
  const { errors, touched, submitCount } =
    useFormikContext<UpdateRequiredFieldsFormModel>()

  const message = (errors as UpdateRequiredFieldsErrors)[groupKey]
  const interacted =
    submitCount > 0 || members.some((member) => getIn(touched, member))
  const invalid = Boolean(message) && interacted

  return { invalid, message: invalid ? message : undefined }
}
